/* Error code returned from Geolocation.getCurrentPosition()
if the user denies access. */
export const LOCATION_DENIED_CODE = 1;
